import Button from "@mlb/react-patterns/dist/components/Button/button";
import { Label } from "@mlb/react-patterns/dist/components/Button/button.style";
import { ButtonShapes } from "@mlb/react-patterns/dist/components/Button/button.types";
import { SpotTagCopy } from "@mlb/react-patterns/dist/components/SpotTag/spotTag.style";
import COLORS from "@mlb/react-patterns/dist/style/universal.color";
import styled from "styled-components";
import { ManageFollowRowContainer, ManageFollowRowInnerContainer } from "../ManageFollowRow/styles";
export var ManageSectionContainer = styled.div.withConfig({
  displayName: "styles__ManageSectionContainer",
  componentId: "sc-9mcpsd-0"
})([""]);
export var ManageSectionHeader = styled.h2.withConfig({
  displayName: "styles__ManageSectionHeader",
  componentId: "sc-9mcpsd-1"
})(["flex:none;font-size:17px;line-height:22px;margin-top:0;margin-bottom:8px;"]);
export var ManageSectionNoDataButton = styled(Button).attrs({
  iconLeft: false,
  iconName: "arrow-next",
  iconSize: 12,
  shape: ButtonShapes.HOLLOW_BORDERLESS
}).withConfig({
  displayName: "styles__ManageSectionNoDataButton",
  componentId: "sc-9mcpsd-2"
})(["align-items:center;background:", ";border-radius:8px;display:flex;flex:none;font-size:16px;justify-content:center;padding:0;", "{margin-right:12px;}&[data-focus-visible-added]{box-shadow:inset 0 0 0 3px rgba(0,137,255,0.65);outline:none;}&:hover{background:", "1A;color:", ";}"], COLORS.mlbGrey1, Label, COLORS.mlbBlack, COLORS.blueRibbon);
export var ManageSectionListContainer = styled.ul.withConfig({
  displayName: "styles__ManageSectionListContainer",
  componentId: "sc-9mcpsd-3"
})(["border-top:1px solid ", ";flex:none;list-style:none;margin-left:-16px;margin-right:-16px;margin-bottom:32px;min-height:80px;padding:0;position:relative;transition:border-top 300ms ease-out 300ms;", ",", "{height:80px;}", "{border-bottom:1px solid ", ";transition:box-shadow 300ms ease-in-out 300ms,z-index 300ms ease-in-out 300ms;z-index:1 !important;", " ", "{padding-left:20px;}", "{font-size:17px;line-height:22px;}}", "{position:absolute;top:0;left:16px;right:16px;}"], function (_ref) {
  var numberOfRows = _ref.numberOfRows;
  return numberOfRows > 0 ? COLORS.mlbGrey2 : "transparent";
}, ManageFollowRowContainer, ManageSectionNoDataButton, ManageFollowRowContainer, COLORS.mlbGrey2, function (_ref2) {
  var rowBeingDragged = _ref2.rowBeingDragged;
  return rowBeingDragged && "\n          &[data-drag-target=\"".concat(rowBeingDragged, "\"]{\n            box-shadow: 4px 4px 8px rgba(0,0,0,0.3);\n            transition: box-shadow 300ms ease-in-out,\n              z-index 300ms ease-in-out;\n            z-index: 2!important;\n          }\n        ");
}, ManageFollowRowInnerContainer, SpotTagCopy, ManageSectionNoDataButton);